export default __webpack_public_path__ + "static/media/nodejs.1708eebd.svg";